<div class="container-fluid service-bg from-top-pad">
    <!-- Titles -->
    <div class="row">
        <div class="col-md-12">
            <h1>
                <a href="#/account">{{'gen_my_account' | translate}}</a> / {{'gen_activate_coupon' | translate}}
            </h1>
            <hr>
        </div>
    </div>

    <!-- Coupon Form -->
    <div class="row">
        <div class="col-md-12">
            <p class="text-center"> {{'account_activate_coupon_msg' | translate}} </p>

            <!-- Form -->
            <div class="form-group mx-auto login-form mt-0" [formGroup]="couponGroup">
                <mat-form-field class="form-element" appearance="fill">
                    <mat-label>{{'gen_coupon' | translate}}</mat-label>
                    <textarea class="in-text-areas" matInput placeholder="{{'gen_coupon' | translate}}"
                        formControlName="coupon"></textarea>

                    <!-- Errors -->
                    <mat-error *ngIf="couponGroup.controls.coupon.errors?.required">{{'error_required_error' |
                        translate}}
                    </mat-error>
                </mat-form-field>

                <button class="button w-100" (click)="activateCoupon()" [disabled]="couponGroup.status == 'INVALID'">
                    <i class="pr-1 fa fa-check"></i>
                    {{'gen_activate_coupon' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>